import {
  call,
  delay,
  takeLatest,
  put,
  select,
  throttle,
} from 'redux-saga/effects';
import * as profilesActions from '../actions/profiles';
import { getEmployeesRequest } from '../../api/profiles/';
import history from '../../../../common/history';
import { getDriversRequest } from '../../api/drivers/getDriversRequest';

const getUserId = state => {
  return (
    state.Authorization &&
    state.Authorization.user &&
    state.Authorization.user.id
  );
};

const getActiveProfileId = state => {
  return (
    state.Authorization &&
    state.Authorization.activeProfile &&
    state.Authorization.activeProfile.profileId
  );
};

function* getEmployeesSaga(action) {
  let userId = yield select(getUserId);
  let activeProfileId = yield select(getActiveProfileId);
  if (userId && activeProfileId) {
    try {
      const response = yield call(getEmployeesRequest, activeProfileId);

      let profiles = {
        stat: { active: { all: 0 }, archive: { all: 0 } },
        active: [],
        archive: [],
        roles: [],
      };
      if (response) {
        let statusActive = ['active', 'wait']; // Все остальные попадают в архивные
        response.forEach(item => {
          let keyName =
            item.profileStatusKey &&
            statusActive.some(status => status === item.profileStatusKey)
              ? 'active'
              : 'archive';
          profiles[keyName].push(item);
          if (item.roleId) {
            profiles.stat[keyName].all++;
            if (profiles.stat[keyName].hasOwnProperty(item.roleKey)) {
              profiles.stat[keyName][item.roleKey]++;
            } else {
              profiles.stat[keyName][item.roleKey] = 1;
              if (!profiles.roles.some(role => role.roleKey === item.roleKey)) {
                profiles.roles.push({
                  roleKey: item.roleKey,
                  role: item.role,
                  roleId: item.roleId,
                });
              }
            }
          }
        });
        profiles.roles.sort((a, b) => a.roleId - b.roleId);
      }
      yield put(profilesActions.getEmployeesSuccess(profiles));
    } catch (err) {
      yield put(profilesActions.getEmployeesError(err));
    }
  } else {
    yield delay(500);
    userId = yield select(getUserId);
    activeProfileId = yield select(getActiveProfileId);
    userId && activeProfileId
      ? yield put(profilesActions.getEmployees())
      : history.push('/authorization/profiles');
  }
}

function* getEmployeesSearchSaga(action) {
  const allEmployees = yield select(state => {
    return (
      state.Employees &&
      state.Employees.profiles &&
      state.Employees.profiles.data
    );
  });
  let profiles = {
    stat: { all: 0 },
    search: [],
    searchValue: null,
  };
  profiles.stat = { all: 0 };
  if (action.payload.search.length > 1) {
    profiles.searchValue = action.payload.search;
    let searchValue = profiles.searchValue.toUpperCase();
    let words = searchValue.split(' ').filter(val => val);
    if (
      allEmployees &&
      Array.isArray(allEmployees[action.payload.typeProfiles])
    ) {
      profiles.search = allEmployees[action.payload.typeProfiles].filter(
        item => {
          let count = 0;
          let searchValues = [item.lastname, item.name, item.patronymic].map(
            val => val && val.toUpperCase()
          );
          words.forEach(word => {
            if (searchValues.some(val => val && val.includes(word))) {
              count++;
            }
          });
          return count >= words.length;
        }
      );
      profiles.search.forEach(item => {
        if (item.roleKey) {
          profiles.stat.all++;
          profiles.stat.hasOwnProperty(item.roleKey)
            ? profiles.stat[item.roleKey]++
            : (profiles.stat[item.roleKey] = 1);
        }
      });
    } else {
      profiles.search = [];
    }
  } else {
    profiles.searchValue = null;
    profiles.search = [];
  }
  yield put(profilesActions.getEmployeesSearchSuccess(profiles));
}
function* getDriversSaga() {
  let userId = yield select(getUserId);
  let activeProfileId = yield select(getActiveProfileId);
  if (userId && activeProfileId) {
    try {
      const response = yield call(getDriversRequest, activeProfileId);
      if (response) {
        yield put(profilesActions.getDriversSuccess(response));
      }
    } catch (e) {}
  } else {
    yield delay(500);
    userId = yield select(getUserId);
    activeProfileId = yield select(getActiveProfileId);
    userId && activeProfileId
      ? yield put(profilesActions.getDrivers())
      : history.push('/authorization/profiles');
  }
}

export function* profilesConfigWatcher() {
  yield takeLatest(profilesActions.getEmployees.toString(), getEmployeesSaga);
  yield throttle(
    80,
    profilesActions.getEmployeesSearch.toString(),
    getEmployeesSearchSaga
  );
  yield takeLatest(profilesActions.getDrivers.toString(), getDriversSaga);
}
